import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Loginservice from "../Services/Service";
import logo from "../Images/VMS.png";
import newBg from "../Images/vms-login-bg.png";
import { startSession } from "../Utils/SessionManager";
import "../styles/login.css";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    // businessId: "",
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  // If already logged in, redirect
  useEffect(() => {
    //sessionStorage.setItem("APIUrl", "https://localhost:7106");
    //use this
    //sessionStorage.setItem("APIUrl", "http://localhost:5211");
    // sessionStorage.setItem("APIUrl", "http://192.168.10.113:5075");
    // sessionStorage.setItem("APIUrl", "http://125.22.105.182:5075");
    sessionStorage.setItem("APIUrl", "https://vmsapi.iecsl.in");

    if (sessionStorage.getItem("isLoggedIn") === "true") {
      navigate("/DashboardFinal", { replace: true });
    }
  }, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  const getUserProfileImage = async (email) => {
    try {
      const url =
        `https://centralizeddemoapi.iecsl.in/api/centralizedAPI/UserDetails` +
        `?companyId=24&Email=${encodeURIComponent(email)}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("UserDetails API failed");
      }

      const result = await response.json();

      console.log("UserDetails API:", result);

      if (result && result.length > 0) {
        const user = result[0];

        // Save employee name
        if (user.Name) {
          sessionStorage.setItem("empname", user.Name);
        }

        // Save profile image
        if (
          user.Data &&
          typeof user.Data === "string" &&
          user.Data.length > 0 &&
          user.Contenttype &&
          typeof user.Contenttype === "string"
        ) {
          const imageSrc =
            `data:${user.Contenttype};base64,${user.Data}`;

          sessionStorage.setItem("profileImage", imageSrc);

          console.log("Profile image saved");
        } else {
          sessionStorage.removeItem("profileImage");
          console.log("No profile image");
        }
      }
    } catch (error) {
      console.error("Profile image API error:", error);
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      //debugger;
      const apiUrl = sessionStorage.getItem("APIUrl") + "/api/Login";
      Loginservice.setApiUrl(apiUrl);

      const response = await Loginservice.create({
        uname: form.username,
        pwd: form.password,
      });

      // const data = response.data;
      // console.log(data);

      const data = response.data;

      console.log("Complete response:", data);
      console.log("Employee data:", data.data);

      if (data.data && data.data.length > 0) {
        console.log("Employee name:", data.data[0].empname);
        console.log("Employee email:", data.data[0].empemail);
        console.log("Employee number:", data.data[0].empno);
      }
      if (data.success) {
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("userEmail", form.username);

        // Start 1-hour inactivity session
        //New
        startSession();

        sessionStorage.setItem("GroupId", data.roleId || 0);

        sessionStorage.setItem("UserType", data.userType); // ADD THIS

        console.log(
          "UserType Before Navigate:",
          sessionStorage.getItem("UserType"),
        );

        // Employee Login
        if (data.data && data.data.length > 0) {
          sessionStorage.setItem("EmpNo", data.data[0].empno);
          sessionStorage.setItem("empname", data.data[0].empname);

          //alert(data.data[0].empname);
          sessionStorage.setItem("CategoryID", 0);

          sessionStorage.setItem("TenantID", data.tenantId);

          console.log("Tenantid:", sessionStorage.getItem("TenantID"));
          // Get profile image before Dashboard opens
          await getUserProfileImage(form.username);
        }

        // Vendor Login
        else if (data.result) {
          // VENDOR LOGIN
          //New
          sessionStorage.setItem("LoginType", data.result.type); // vendor
          sessionStorage.setItem("empname", data.result.vendorName);
          sessionStorage.setItem("VendorID", data.result.vendorID);
          sessionStorage.setItem("VendorName", data.result.vendorName);
          sessionStorage.setItem("CategoryID", data.result.categoryID);
          sessionStorage.setItem("TenantID", data.result.tenantID);
        }

        // Set session flag so upper-right snackbar reliably appears immediately on Dashboard/Registration
        sessionStorage.setItem("showLoginSuccess", "true");
        sessionStorage.setItem("loginSuccessUser", form.username);

        if (data.data && data.data.length > 0) {
          // Employee → existing Dashboard
          navigate("/DashboardFinal", { state: { showLoginSuccess: true, username: form.username } });
        } else if (data.result) {
          // Vendor → directly Registration
          navigate("/Registration", { state: { showLoginSuccess: true, username: form.username } });
        } else {
          // Fallback → Dashboard
          navigate("/DashboardFinal", { state: { showLoginSuccess: true, username: form.username } });
        }
      } else {
        alert(data.message || "Invalid credentials");
      }
    } catch (err) {
      console.error("Login Error:", err);
      alert("Login failed");
    }
  }

  // ...
  const pageStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    margin: 0,
    padding: 0,
    backgroundImage: `url(${newBg})`,
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div style={pageStyle}>

      {/* ══════════════ LEFT PANEL ══════════════ */}
      <div className="login-left-panel">
        <div className="login-left-content">
          <p className="login-subtitle">Smart Vendor Management</p>

          <h1 className="login-heading">
            Smarter Vendors.<br />
            <span className="text-blue">Stronger</span> <span className="text-green">Business.</span>
          </h1>

          <p className="login-description">
            Streamline vendor collaboration, ensure compliance
            and drive growth — all in one place.
          </p>
        </div>
      </div>

      {/* ══════════════ RIGHT PANEL ══════════════ */}
      <div className="login-right-panel">
        <div className="login-form-card">
          {/* Welcome Text */}
          <h2 className="login-welcome-title" style={{ textTransform: 'uppercase', fontSize: '10.5px', letterSpacing: '2px', color: '#64748b', textAlign: 'center', margin: '0 0 12px 0', fontWeight: '700' }}>
            WELCOME TO
          </h2>

          {/* Logo */}
          <div className="login-logo-box" style={{ display: 'flex', justifyContent: 'center', margin: '0 0 20px 0' }}>
            <img src={logo} alt="ieVMS Logo" className="login-logo-img" style={{ maxWidth: '150px', height: 'auto', objectFit: 'contain' }} />
          </div>

          <p className="login-welcome-sub" style={{ textAlign: 'center', color: '#64748b', fontSize: '12.5px', margin: '0 0 16px 0', fontWeight: '450' }}>
            Sign in to continue to your workspace
          </p>

          {/* Login Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            {/* Username / Email */}
            <div className="login-field">
              <MailOutlineIcon className="login-field-icon" />
              <input
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="Email or User Name"
                className="login-field-input"
                required
                autoComplete="username"
              />
            </div>

            {/* Password */}
            <div className="login-field">
              <LockOutlinedIcon className="login-field-icon" />
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Password"
                className="login-field-input"
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </button>
            </div>

            {/* Remember Me / Forgot Password */}
            <div className="login-options">
              <label className="login-remember">
                <input type="checkbox" className="login-checkbox" />
                Remember me
              </label>
             
            </div>

            {/* Submit Button */}
            <button type="submit" className="login-btn">
              Sign In
              <ArrowForwardIcon className="login-btn-arrow" fontSize="inherit" />
            </button>
          </form>
        </div>
      </div>

      {/* ══════════════ FOOTER ══════════════ */}
      <footer className="login-footer">
        <p className="login-footer-text">
          Email:{" "}
          <a href="mailto:info@iecscl.co.in" className="login-footer-link">
            info@iecscl.co.in
          </a>{" "}
          | Support:{" "}
          <a href="tel:+918339902198" className="login-footer-link">
            +91 83399-02198
          </a>{" "}
          | Web:{" "}
          <a href="https://iecscl.com" className="login-footer-link">
            IECSL
          </a>
          &nbsp;&nbsp;•&nbsp;&nbsp;
          © 2025 Mendine VMS •{" "}
          <a href="#terms" className="login-footer-link">Terms</a> &{" "}
          <a href="#privacy" className="login-footer-link">Privacy</a>
        </p>
      </footer>
    </div>
  );
}
